var Status;
(function(Status2) {
  Status2["Unknown"] = "unknown";
  Status2["Skipped"] = "skipped";
  Status2["Success"] = "success";
  Status2["RateLimit"] = "rate_limit";
  Status2["PayloadTooLarge"] = "payload_too_large";
  Status2["Invalid"] = "invalid";
  Status2["Failed"] = "failed";
  Status2["Timeout"] = "Timeout";
  Status2["SystemError"] = "SystemError";
})(Status || (Status = {}));
export {
  Status
};
//# sourceMappingURL=status.js.map
